<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card :header="caption">
          <template slot="header">
            <b-row>
              <b-col cols="6">
                Schedules
              </b-col>
              <b-col cols="6" class="text-right">
                <b-btn size="sm" variant="success" @click="add"><i class="icon-plus mr-1"></i>Add</b-btn>
              </b-col>
            </b-row>
          </template>
          <loading :isLoading="isLoading" :items="schedules" noItemsText="No Schedules"></loading>
          <div class="animated fadeIn" v-if="!isLoading && schedules.length > 0">
            <b-table :hover="true" class="mb-2 table-outline" responsive="sm" head-variant="light" :items="schedules" :fields="fields" :current-page="currentPage" :per-page="perPage" @row-clicked="rowClicked">
              <template v-slot:cell(numbers)="data">
                <span v-show="data.value.length == 0">No Numbers Configured</span>
                <b-badge size="md" v-for="number in data.value" v-bind:key="number.id" variant="primary">
                  <phone-number v-model="number.number"></phone-number>
                </b-badge>
              </template>
            </b-table>
            <nav>
              <b-pagination :total-rows="getRowCount(schedules)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <add-schedule-modal @add="addSchedule" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Loading from '@/components/text/Loading'
import Date from '@/components/text/Date'
import PhoneNumber from '@/components/text/PhoneNumber'
import AddScheduleModal from './partials/AddSchedule'

export default {
  name: 'schedules',
  computed: {
    ...mapGetters({
      account: 'global/account',
      schedules: 'account/schedules'
    })
  },
  components: {
    AddScheduleModal,
    Date,
    Loading,
    PhoneNumber
  },
  data () {
    return {
      caption: 'Schedules',
      isLoading: false,
      hover: false,
      striped: true,
      bordered: false,
      small: false,
      fixed: false,
      fields: [
        { key: 'name' },
        { key: 'numbers' },
        { key: 'status', label: '', class: 'text-right' }
      ],
      currentPage: 1,
      perPage: 20,
      totalRows: 0
    }
  },
  methods: {
    add () {
      this.$bus.$emit('modal:addSchedule')
    },
    addSchedule (recording) {
      this.$router.push(`/calling/schedules/${recording.id}`)
    },
    rowClicked (row) {
      this.$router.push(`/calling/schedules/${row.id}`)
    },
    getRowCount (items) {
      return items.length
    },
  },
}
</script>
<style lang="scss" scoped>
td {
  span {
    &.badge {
      margin-right: .5rem;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
